import { createAction } from '@mews/framework';
import prefix from '../prefix';

export const NETWORK_STATUS_CHANGED = prefix('NETWORK_STATUS_CHANGED');

export function networkStatusChangeOffline() {
    return (dispatch: $TSFixMe) => dispatch(createAction(NETWORK_STATUS_CHANGED, false));
}

export function networkStatusChangeOnline() {
    return (dispatch: $TSFixMe) => dispatch(createAction(NETWORK_STATUS_CHANGED, true));
}
